(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dr-image-with-frame"] && !Shopify.designMode) return;
  try {
    
var accordian_title = document.querySelectorAll(".product__accordion .details");
var accordian_description = document.querySelectorAll(".product__accordion-dropdown-content .icon-dropdown ");

function showContent(index) {
  for (var i = 0; i < accordian_title.length; i++) {
    if (i === index) {
      // Toggle the active class if the clicked item is already active
      accordian_title[i].classList.toggle("active");
      accordian_description[i].classList.toggle("active");
    } else {
      accordian_title[i].classList.remove("active");
      accordian_description[i].classList.remove("active");
    }
  }
}

accordian_title.forEach(function (circle, index) {
  circle.addEventListener("click", function () {
    showContent(index);
  });
});

// Show the initial content (one_content)
showContent(0);

  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drKnotWorks_Section"] && !Shopify.designMode) return;
  try {
    
      var circleBorders = document.querySelectorAll(".circle_border");
      var contentParagraphs = document.querySelectorAll(".circle_container .circle_content");

      function showContent(index) {
        for (var i = 0; i < circleBorders.length; i++) {
          circleBorders[i].classList.remove("active");
          contentParagraphs[i].classList.remove("active");
        }

        circleBorders[index].classList.add("active");
        contentParagraphs[index].classList.add("active");
      }

      circleBorders.forEach(function (circle, index) {
        circle.addEventListener("click", function () {
          showContent(index);
        });
      });

      // Show the initial content (bm_one_content)
      showContent(0);

  } catch(e) { console.error(e); }
})();
})();
